<div class="ag-media row flex-nowrap">
  <div class="ag-media__menu col-auto">
    <div class="ag-media__add-folder row flex-nowrap" *ngIf="canCreate">
      <dx-text-box
        class="col"
        [(value)]="folderName"
        placeholder="Enter New Folder Name"
        [maxLength]="50"
        [showClearButton]="true"
      ></dx-text-box>

      <dx-button
        class="col-auto"
        icon="agi-folder-plus"
        stylingMode="outlined"
        type="default"
        hint="Add Folder"
        [disabled]="!folderName"
        (onClick)="addFolder()"
      ></dx-button>
    </div>

    <hr />

    <p class="ag-empty-text text-center" *ngIf="!directoriesDataSource?.length">No folders</p>

    <dx-menu
      [dataSource]="directoriesDataSource"
      displayExpr="name"
      orientation="vertical"
      [hideSubmenuOnMouseLeave]="false"
      itemTemplate="items"
      (onItemClick)="itemClick($event)"
    >
      <div
        *dxTemplate="let item of 'items'; let index = index"
        [ngClass]="{ 'selected-item': index === selectedItemIndex }"
        (click)="onItemClick(index)"
      >
        <i class="dx-icon-agi-folder"></i> {{ item.name }}

        <ng-container *ngIf="!item.isSystem && canDelete">
          <dx-button
            class="remove-button"
            [icon]="'close'"
            [stylingMode]="'text'"
            (onClick)="deleteFolder(item)"
          ></dx-button>
        </ng-container>
      </div>
    </dx-menu>
  </div>

  <div class="ag-media__gallery col">
    <ag-shr-media-gallery
      [mediaItems]="agentMediaComponentService.currentMediaList$ | async"
      [mediaActions]="extraMediaActions"
      [allowActions]="canEdit"
      [allowDelete]="canDelete"
      [sourceType]="sourceType"
      (itemDeleted)="onDeleteClicked($event)"
      (onDownloadMedia)="onDownloadMedia($event)"
    ></ag-shr-media-gallery>

    <div class="gallery-actions">
      <shr-button-with-indicator
        *ngIf="canCreate"
        [title]="'Upload a File'"
        [icon]="'upload'"
        [agMergeGuard]="agentDbId"
        (agMergeGuardedClick)="uploadFileClicked()"
      ></shr-button-with-indicator>
    </div>
  </div>
</div>

<ag-shr-media-uploader-modal
  [mediaPathPrefix]="mediaPathPrefix$ | async"
  [waitForProcessing]="true"
  (mediaChanged)="onMediaChanged($event)"
  [mediaSources]="[MediaUploaderTabs.FromFile, MediaUploaderTabs.ByURL]"
></ag-shr-media-uploader-modal>
